/** Frequency (Hz) of a MIDI note number, A4 = 69 = 440 Hz. */
export const midi = (n: number) => 440 * 2 ** ((n - 69) / 12);
